module.exports = __webpack_public_path__ + "static/media/personCircle.2cd13072.svg";